import {StructureId} from "./StructureId.js";
import StructureForms from "../../components/StructureFormSelector/StructureForms.js";
import StructureIdList from "./StructureIdList.js";

export class StructRepository {
    /** @type {HttpClient} */
    #httpClient;
    #baseUrl = '/api/structure';

    /** @param {HttpClient} httpClient */
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }

    /**
     * @param {string|File} structure or structures if it's an SDF
     * @returns {Promise<StructureId[]>}
     */
    async register(structure) {
        const response = await this.#httpClient.fetch(this.#baseUrl, {
            method: 'PUT',
            body: structure,
            headers: {
                'Content-Type': 'chemical/x-daylight-smiles'
            }
        });
        return StructureId.parseServerJsonList(await response.json())
    }

    /**
     *
     * @param {StructureIdSearch[]} req
     * @returns {Promise<StructureId[][]>}
     */
    async find(req) {
        const response = await this.#httpClient.fetch(this.#baseUrl + '/list', {
            method: 'PUT',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const array = await response.json();
        const result = [];
        for (const next of array)
            result.push(StructureId.parseServerJsonList(next));
        return result;
    }

    /**
     * @param {String[]} parents
     * @param {StructureId[]?}structureIds
     * @return {Promise<StructureForms[]>}
     */
    async findForms(parents, structureIds) {
        const response = await this.#httpClient.fetch(this.#baseUrl + '?parent=' + parents.join(','));
        return StructureForms.parseJsonList(await response.json(), structureIds);
    }
}